var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('back',[_vm._v("级联选择")]),_c('Picker',{attrs:{"columns":_vm.columns},on:{"change":_vm.onChange}}),_c('Button',{attrs:{"filter":_vm.update},on:{"click":_vm.goToWithParam}},[_vm._v("跳转带参")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }